"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.HoverObserver = void 0;
const tslib_1 = require("tslib");
const react_1 = tslib_1.__importDefault(require("react"));
const utils_1 = require("../../utils");
const Noop = () => {
    return;
};
/**
 * # 🛸 HoverObserver
 *
 * A React component that notifies its children of hover interactions.
 *
 * Initial code taken from: https://github.com/ethanselzer/react-hover-observer.
 *
 * ## Usage
 * ```jsx
 * <HoverObserver>
 *  {({ isHovering }) => (
 * 		 <YourChildComponent isActive={isHovering} />
 *  )}
 * </HoverObserver>
 * ```
 */
class HoverObserver extends react_1.default.PureComponent {
    constructor(props) {
        super(props);
        this.timerIds = [];
        this.state = {
            isHovering: false,
        };
        this.onMouseEnter = this.onMouseEnter.bind(this);
        this.onMouseLeave = this.onMouseLeave.bind(this);
        this.onMouseOver = this.onMouseOver.bind(this);
        this.onMouseOut = this.onMouseOut.bind(this);
        this.setIsHovering = this.setIsHovering.bind(this);
        this.unsetIsHovering = this.unsetIsHovering.bind(this);
        this.componentWillUnmount = this.componentWillUnmount.bind(this);
        this.timerIds = [];
    }
    onMouseEnter(e) {
        this.props.onMouseEnter({
            e,
            setIsHovering: this.setIsHovering,
            unsetIsHovering: this.unsetIsHovering,
        });
    }
    onMouseLeave(e) {
        this.props.onMouseLeave({
            e,
            setIsHovering: this.setIsHovering,
            unsetIsHovering: this.unsetIsHovering,
        });
    }
    onMouseOver(e) {
        this.props.onMouseOver({
            e,
            setIsHovering: this.setIsHovering,
            unsetIsHovering: this.unsetIsHovering,
        });
    }
    onMouseOut(e) {
        this.props.onMouseOut({
            e,
            setIsHovering: this.setIsHovering,
            unsetIsHovering: this.unsetIsHovering,
        });
    }
    componentWillUnmount() {
        this.clearTimers();
    }
    setIsHovering() {
        this.clearTimers();
        const hoverScheduleId = setTimeout(() => {
            const newState = { isHovering: true };
            this.setState(newState, () => {
                this.props.onHoverChanged(newState);
            });
        }, this.props.hoverDelayInMs);
        this.timerIds.push(hoverScheduleId);
    }
    unsetIsHovering() {
        this.clearTimers();
        const hoverOffScheduleId = setTimeout(() => {
            const newState = { isHovering: false };
            this.setState(newState, () => {
                this.props.onHoverChanged(newState);
            });
        }, this.props.hoverOffDelayInMs);
        this.timerIds.push(hoverOffScheduleId);
    }
    clearTimers() {
        const ids = this.timerIds;
        while (ids.length) {
            const id = ids.pop();
            clearTimeout(id);
        }
    }
    render() {
        const { children } = this.props;
        return (react_1.default.createElement("div", Object.assign({}, {
            onMouseEnter: this.onMouseEnter,
            onMouseLeave: this.onMouseLeave,
            onMouseOut: this.onMouseOut,
            onMouseOver: this.onMouseOver,
        }), utils_1.renderChildrenWithProps(children, this.state)));
    }
}
exports.HoverObserver = HoverObserver;
HoverObserver.defaultProps = {
    hoverDelayInMs: 0,
    hoverOffDelayInMs: 0,
    onHoverChanged: Noop,
    onMouseEnter: ({ setIsHovering }) => setIsHovering(),
    onMouseLeave: ({ unsetIsHovering }) => unsetIsHovering(),
    onMouseOut: Noop,
    onMouseOver: Noop,
};
